import { createContext, useContext, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import { fetchUserDetails } from '../utilities/authUtils';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userType, setUserType] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDetails = await fetchUserDetails(user.uid);
        setIsAdmin(userDetails.isAdmin);
        setUserType(userDetails.userType);
        setCurrentUser(user);
      } else {
        setIsAdmin(false);
        setUserType(null);
        setCurrentUser(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const logout = async () => {
    const auth = getAuth();
    await signOut(auth);
    navigate('/sign-in');
  };
  return (
    <AuthContext.Provider value={{ currentUser, logout, isAdmin, userType, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
